<template>
  <div>
    <div class="Company_box">
                <p class="Company_text">公司概况</p>
                <div  class="arrow-right">
                   <el-breadcrumb separator-class="el-icon-arrow-right">
                   <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                   <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                  <el-breadcrumb-item>企业概况</el-breadcrumb-item>
                  <el-breadcrumb-item>公司概况</el-breadcrumb-item>
                   </el-breadcrumb>
                   </div>
              </div>
      <div class="enterprise_name">———企业概况————</div> 
      <div class="enterprise_box">
                <div class="enterprise_img">
                  <img src="../assets/img/gs103.jpg" alt="">
                </div>
                   <div class="enterprise_text">
                  &nbsp;&nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
                  中国船舶集团有限公司是按照党中央决策、经国务院批准，于2019年10月14日由
                  原中国船舶工业集团有限公司与原中国船舶重工集团有限公司联合重组成立的特
                  大型国有重要骨干企业，有科研院所、企业单位和上市公司113家,资产总额8400亿元，
                  员工34.7万人拥有我国最大的造修船基地和最完整的船舶及配套产品研发能力
                  中国船舶集团有限公司是按照党中央决策、经国务院批准，于2019年10月14日
                  由原中国船舶工业集团有限公司与原中国船舶重工集团有限公司联合重组成立
                  的特大型国有重要骨干企业，有科研院所、企业单位和上市公司113家,
                  资产总额8400亿元，员工34.7万人拥有我国最大的造修船基地和最完整的船舶及配套产品研发能力.
                </div> 
              </div>
              <div class="Organization_box">
               <div class="Organization_img">公司高管</div>
                <div class="Organization_img">组织架构</div>
               </div>
  </div>
</template>
<script>
export default {
      data(){
        return{
          tabPosition: 'left'
        }
      }
}
</script>
<style>
.enterprise_name{
  font-size: 1.5vw;
   color: #0c47a1;
  text-align: center;
  margin-top: 1vw;
}
.enterprise_box{
  width: 100%;
  height: 17vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
}
.enterprise_img{
  width: 15vw;
  height: 15vw;
}
.enterprise_img img{
  width: 100%;
  height: 100%;
}
.enterprise_text{
  width: 80%;
  height: 100%;
  font-size: 1.5vw;
}
.Organization_box{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.Organization_img{
  width: 37vw;
  height: 17vw;
  background: url("../assets/img/gss07.jpg") no-repeat;
  background-size: 100%;
  text-align: center;
  line-height: 18vw;
  font-size: 2vw;
  color:#fff; 
}
.Company_box{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dedede;
}
.Company_text{
 
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
   font-weight: bold;
}
.arrow-right{
  text-align: center;
 margin-top: 0.5vw;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise.vue